import React from "react";

const StatCard = ({ icon, label, value, sub, accent = "#6366f1", iconBg = "#eef2ff" }) => (
  <div
    className="stat-card"
    style={{ "--stat-accent": accent, "--stat-icon-bg": iconBg }}
  >
    {icon && <div className="stat-card-icon">{icon}</div>}
    <div className="stat-card-label">{label}</div>
    <div className="stat-card-value">{value}</div>
    {sub && <div className="stat-card-sub">{sub}</div>}
  </div>
);

export default StatCard;
